/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeletionImpactDto } from '../../models/deletion-impact-dto';

export interface ProductsControllerGetDeletionImpact$Params {
  id: string;
}

export function productsControllerGetDeletionImpact(http: HttpClient, rootUrl: string, params: ProductsControllerGetDeletionImpact$Params, context?: HttpContext): Observable<StrictHttpResponse<DeletionImpactDto>> {
  const rb = new RequestBuilder(rootUrl, productsControllerGetDeletionImpact.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeletionImpactDto>;
    })
  );
}

productsControllerGetDeletionImpact.PATH = '/products/{id}/deletion-impact';
